var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28 28","width":"28","height":"28"}},[_c('path',{attrs:{"fill":"currentColor","d":"m25.39 7.31-8.83 10.92-6.02-5.47-7.16 8.56-.76-.64 7.82-9.36 6 5.45L24.61 6.7l.78.62Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }